export default __webpack_public_path__ + "static/media/card-purp.9c5cfc0b.png";